import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';
import { UiService } from '../ui/ui.service';
import { UserService } from '../user/user.service';
import { Router } from '@angular/router';
import { fromPromise } from 'rxjs/observable/fromPromise';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {


    constructor(
        private ui: UiService,
        private userService: UserService,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('access_token');

        const contentType = req.headers.get('Content-Type') || 'application/json';
        let headers = req.headers;

        if (!headers.get('no-content-type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        if (token) {
            headers = headers.set('Authorization', 'Bearer ' + token);
        }

        const url = req.url.includes('auth')
            ? environment.apiUrl + req.url
            : (req.url.startsWith('/bmi-')) ? environment.apiUrl + req.url : environment.authApiUrl + req.url;

        req = req.clone({
            headers,
            url
        });
        return next.handle(req)
            .catch(err => {
                const errorObj = {};
                if (err instanceof HttpErrorResponse) {
                    const error = err.error;
                    if (err.status === 403) {
                        localStorage.clear();
                        swal(error.errmsg, '', 'warning');
                        this.router.navigate(['login']);
                    } else if (err.status === 401 && err.error.message && err.error.message.toLowerCase().includes('token')) {
                        this.userService.info = null;
                        localStorage.clear();
                        // localStorage.removeItem('access_token');
                        this.router.navigate(['login']);
                        setTimeout(() => {
                            this.ui.loader.reset();
                        }, 2000);
                        swal('Unauthorized', '', 'error');
                        return Observable.throw(null);
                    }
                    if (error.status_code >= 500) {
                        swal('Oops!', 'Something went wrong', 'error');
                    } else if (error.message) {
                        if (localStorage.getItem('jwt-logout')) {
                            localStorage.removeItem('jwt-logout');
                        } else {
                            swal('Oops!', error.message, 'error');
                        }
                    } else if (error.errmsg) {
                        const msg = error.errmsg;
                        if (typeof msg === 'string') {
                            swal(msg, '', 'warning');
                        } else {
                            Object.keys(msg).forEach(key => {
                                errorObj[key] = msg[key][0];
                            });
                        }
                    } else {
                        swal('Oops!', 'Something went wrong', 'error');
                    }
                }
                return Observable.throw(errorObj);
            });
    }
}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/services/api-interceptor/api-interceptor.ts